import axios, {AxiosError, AxiosInstance, AxiosResponse} from 'axios';
import {InlineArrayResult, inlinePromise} from "@/lib/promise-util";

export const api = axios.create({
    baseURL: process.env.NEXT_PUBLIC_BASE_URL
})
export const apiInternal = axios.create({
    baseURL: process.env.NEXT_PUBLIC_BASE_URL
})

export const apiExternal  = axios.create();

export interface ApiListResponse<T> {
    count: number;
    list: T[]
}

export const configureApi = (baseUrl: string) => {
    api.defaults.baseURL = baseUrl;
}

export const configureToken = (token: string) => {
    api.defaults.headers.common['Authorization'] = 'Bearer ' + token;
}
export const configureWhitelabelToken = (token: string) => {
    api.defaults.headers.common['x-whitelabel-token'] = token;
}

export interface ApiData<T> {

    data: {
        data: T
        message: string
        status: number
    }
}


export const setAuthToken = (api: AxiosInstance, token: string) => {
    api.defaults.headers.common['Authorization'] = 'Bearer ' + token;
}

export const commonApiWrapper = async <T>(apiPromise: Promise<any>): Promise<InlineArrayResult<T>> => {
    const [response, error] = await inlinePromise<ApiData<T>>(apiPromise);
    if (error) {
        return [null as T, error]
    }
    return [response?.data?.data ?? {} as T, null]
}

export const commonExternalWrapper = async <T>(apiPromise: Promise<any>): Promise<InlineArrayResult<T>> => {
    const [response, error] = await inlinePromise<AxiosResponse<T>>(apiPromise);
    if (error) {
        return [null, error]
    }
    // @ts-ignore
    return [response.data, null]
}


export const getErrorDataFromResponse = <T = any>(error: any) => {
    const axiosError = error as AxiosError;
    return (axiosError?.response?.data ?? {}) as T;
}